export function LeftArrowImageModalMobile() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="white" fillOpacity="0.8" />
      <path
        d="M14 16L10 12L14 8"
        stroke="#555555"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
